import styled from "styled-components";

export const PubListWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;

  .title {
    font-size: 24px;
    font-weight: 700;
    color: #000;
    text-align: center;
    font-family: Pretendard;
  }
`;

export const PubListFormWrapper = styled.div`
  width: 100%;
  height: 500px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;

  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;

export const PubListItemWrapper = styled.div`
  background-color: #fff;
  padding: 20px 25px;
  color: #000;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  width: 768px;

  > img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;

export const PubListFormName = styled.div`
  color: #111827;
  font-family: "Pretendard";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 21.5px; /* 119.444% */
  display: flex;
  algin-items: center;
  gap: 12px;

  > .login {
    border-radius: 9999px;
    background: #f2e9ff;
    display: flex;
    padding: 2px 7.648px 2px 8px;
    justify-content: center;
    align-items: center;
    color: #550fbe;
    font-size: 11px;
    font-weight: 600;
  }
`;

export const PubListFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #6b7280;
  font-family: "Pretendard";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px; /* 121.429% */
`;
